import {checkConditions} from "@/2_app-logic/utils/utils";
import store from '../store'
import * as _ from "lodash"

// export class Query {
//     paginator = new QueryPage(1, 2)
//
//     _pending = false
//     _resolve = false
//     _rejected = false
//     _complete = false
//
//     _request = null
//
//     constructor(request) {
//         this._request = request
//     }
//
//     send() {
//         this._request()
//
//         this._pending = true
//         this._resolve = false
//         this._rejected = false
//         this._complete = false
//     }
//
//     resolve() {
//         this._resolve = true
//         this._complete = true
//     }
//
//     rejected() {
//         this._rejected = true
//         this._complete = true
//     }
// }


class BaseParams {
    _params

    constructor(params= {}) {
        this._params = params
    }

    // страница пагинатора
    set page(value) {
        this._params.page = value
        return this
    }

    // количество элементов на странице
    set page_size(value) {
        this._params.page_size = value
        return this
    }

    // день "на" который показать статистику (машина времени взад), по-умолчанию, сегодня
    set date(value) {
        this._params.date = value
        return this
    }

    // по каким источникам нужна стата (по-умолчанию, по всем)
    set sources(value) {
        this._params.sources = value
        return this
    }

    sort() {

    }

    prepareSearchParams() {
        return copyParamsInSearchParams({}, this._params)

        function copyParamsInSearchParams(base, params) {
            for (let key in params) {
                // eslint-disable-next-line no-prototype-builtins
                if (!params.hasOwnProperty(key)) continue

                if (key === 'filter') {
                    // prepareFilterParams(base, params[key])
                } else if (key === 'sort') {
                    // prepareSortParams(base, params[key])
                } else if (_.isObject(params[key]) && !_.isFunction(params[key]) && key !== 'filter' && key !== 'sort') {
                    // copyParamsInSearchParams(base, params[key])
                } else if (Array.isArray(params[key])) {
                    base[key] = params[key].join(',')
                } else {
                    base[key] = params[key]
                }
            }

            return base
        }

        function prepareSortParams(base, params) {
            let value = ''

            for (let key in params) {
                // eslint-disable-next-line no-prototype-builtins
                if (!params.hasOwnProperty(key)) continue

                if (value !== '') {
                    value += ','
                }

                if (params[key]) {
                    value += key + '_ASC'
                } else {
                    value += key + '_DESC'
                }
            }

            if (value) base['filter[order_by]'] = value
        }
    }
}


class BaseQuery {
    _actionPath // доменный путь эндпоинта, путь для выполнения действия
    _params // GET-параметры
    _body // Тело запроса, если это POST
    _response // Ответ на запрос
    _isType_mainOnPage // Определяет, главный ли это запрос на странице. Если да, то его параметры переносятся в адресную строку.
    _countOfRequests // Количесвто вызовов по этому запросу

    constructor(actionPath, params = new BaseParams(), body = {}, isType_mainOnPage = false) {
        this._actionPath = actionPath
        this._params = params instanceof BaseParams ? params : new BaseParams(params)
        this._body = body
        this._isType_mainOnPage = isType_mainOnPage

        this.state = 'ready'
        this._countOfRequests = 0
    }

    //==============================

    get isType_mainOnPage() {
        return this._isType_mainOnPage
    }

    get isFirstRequest() {
        return this._countOfRequests === 1
    }

    set response(response) {
        this._response = response
        this.updatePageParamsFromResponse(response)
    }

    get response() {
        return this._response
    }

    // TODO @Observable
    pending = false

    // TODO @Action
    pendingStart() {
        this.pending = true
        this.state = 'pending'
        this._countOfRequests++
        // console.log('pendingStart', this._body.action, this.pending)

        this.mergeParamsWithInitRouteQuery(store)
    }

    // TODO @Action
    fulfilled() {
        this.pending = false
        this.state = 'fulfilled'
        // console.log('fulfilled', this._body.action, this.pending)
    }

    // TODO @Action
    failed(error) {
        this.pending = false
        this.state = 'failed'
        this.error = error
        // console.log('failed', this._body.action, this.pending)
    }

    pendingName // То чего ожидает клиент запроса: модель или коллекция. По этому имены запросы мапятся в Model.mete.pending

    // TODO @Observable
    state // 'ready' | 'pending' | 'fulfilled' | 'failed'

    // TODO @Observable
    error // Object

    copy() {
        return _.cloneDeep(this)
    }

    cloneAndReset() {
        return this.copy()._reset()
    }

    //================================


    // get actionPath() {
    //     return this._actionPath
    // }

    get params() {
        return this._params
    }

    // get searchParams() { // Подготовленные параметры для http-запроса
    //     return this._params.prepareSearchParams()
    // }

    /**
     * Данные о пагинации
     * Собираются из запроса и ответа
     */
    get paginator() {
        const responsePaginator = this.response && this.response.data.paginator

        // Обновляем параметры запроса страницы, поскольку после ответа они могут измениться на единственно возможные

        if (checkConditions([this._params._params.page, responsePaginator])) {
            let page_size = parseInt(this._params._params.page_size)
            let page = parseInt(responsePaginator.page)
            return {
                page: page,
                page_size: page_size
            }
        }
        else if (this._params._params.page) {
            let page_size = parseInt(this._params._params.page_size)
            let page = parseInt(this._params._params.page)
            return {
                page: page,
                page_size: page_size
            }
        }
        else {
            console.warn('Нет данных для пагинации')
            return null
        }
    }

    get requestUrl() {
        return this._actionPath + '?' + new URLSearchParams(this._params.prepareSearchParams()).toString()
    }

    get requestUrl__GET() {
        this._params._params.action = this._body.action
        return this.requestUrl
    }

    get body() {
        return this._body
    }

    // get key() {
    //     return Md5.hashStr( this._actionPath + JSON.stringify(this.params) )
    // }

    _reset() {
        this.error = null
        this.state = 'ready'
        this.pending = false
        return this
    }

    /**
     * При инициализации приложения, пробросить параметры из урла в параметры запроса
     */
    mergeParamsWithInitRouteQuery() {
        if (this.isType_mainOnPage) {
            store.state.currentPageQuery = this
        }

        if (this.isType_mainOnPage && this.isFirstRequest && !store.state.init.routeQueryIsAlreadySet) {
            this._params._params = {...this._params._params, ...store.state.init.routeQuery}
            store.state.init.routeQueryIsAlreadySet = true

            // console.log(
            //     'BEFORE REQUEST, mergeParamsWithInitRouteQuery',
            //     this._body.action,
            //     Object.entries(this._params._params)[2],
            //     Object.entries(storeInit.routeQuery)[2]
            // );
        }
    }

    /**
     * Установить произвольный параметр
     * @param param {key: string, value: string}
     * @returns {BaseQuery}
     */
    setQueryParam(param) {
        // console.log('setQueryParam', this._body.action, param)

        if (param.value === null || param.value === undefined) {
            delete this._params._params[param.key]
        }
        else {
            this._params._params[param.key] = param.value
        }
        return this
    }

    /**
     * Обновляем параметры запроса страницы, поскольку после ответа они могут измениться на единственно возможные
     * Запрашивали страницу номер 2, а данных только на 1.
     * Это нужно сделать по той причине, что параметры адресной строки обновляются из параметров запроса.
     */
    updatePageParamsFromResponse(response) {
        if (response && response.data.paginator && response.data.paginator.page) {
            this._params._params.page = response.data.paginator.page || null
        }
    }
}



export class BranchListQuery extends BaseQuery {
    constructor(isType_mainOnPage = false, params = new BaseParams()) {
        super('', params, {action: 'branches_list'}, isType_mainOnPage)
    }
}

export class KeywordListQuery extends BaseQuery {
    constructor(isType_mainOnPage = false, params = new BaseParams()) {
        super('', params, {action: 'keywords_list'}, isType_mainOnPage)
    }

    // фильтр по фразе (вхождение)
    keyword_q(value) {
        this._params._params.keyword_q = value
        return this
    }

    // фильтр по фразе (точное совпадение)
    keyword(value) {
        this._params._params.keyword = value
        return this
    }

    // показать ключевики, которые вошли в топ 3 по какому-нибудь источнику (может быть добивятся топ 5, топ 10)
    top(value) {
        this._params._params.sources = value
        return this
    }
}

export class KeywordStatsQuery extends BaseQuery {
    constructor(isType_mainOnPage = false, params = new BaseParams()) {
        super('', params, {action: 'rank_by_keyword'}, isType_mainOnPage)
    }

    // фильтр по фразе (точное совпадение)
    keyword(value) {
        this._params._params.keyword = value
        return this
    }
}

export class BranchStatsQuery extends BaseQuery {
    constructor(isType_mainOnPage = false, params = new BaseParams()) {
        super('', params, {action: 'rank_by_branch'}, isType_mainOnPage)
    }

    branchId(value) {
        this._body.branch_id = value
        return this
    }

    // фильтр по фразе (вхождение)
    keyword_q(value) {
        this._params._params.keyword_q = value
        return this
    }

    // фильтр по фразе (точное совпадение)
    keyword(value) {
        this._params._params.keyword = value
        return this
    }

    // показать ключевики, которые вошли в топ 3 по какому-нибудь источнику (может быть добивятся топ 5, топ 10)
    top(value) {
        this._params._params.sources = value
        return this
    }
}

export class ProjectBranchesListQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('', params, {action: 'get_project_branches'})
    }
}

export class ProjectSourcesListQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('', params, {action: 'get_project_sources'})
    }
}

export class KeywordsListPositionHistoryQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('', params, {action: 'keywords_list_position_history'})
    }
}

export class RankByBranchPositionHistoryQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('', params, {action: 'keywords_list_position_history'}) // keywords_list_position_history - да, так надо
    }
}

export class RankByKeywordPositionHistoryQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('', params, {action: 'rank_by_keyword_position_history'})
    }
}

/**
 * Базовый запрос для раздела KeywordsManagement
 * action задается отдельно в body
 */
class KeywordsManagementQuery extends BaseQuery {
    constructor(params = new BaseParams()) {
        super('keywords-management/', params)
    }
}

export class KeywordsManagement__BranchesCardsQuery extends KeywordsManagementQuery {
    constructor(params = new BaseParams()) {
        super()
        this._body.action = 'get_branches_cards'
    }
}

export class KeywordsManagement__KeywordsQuery extends KeywordsManagementQuery {
    constructor(params = new BaseParams()) {
        super()
        this._body.action = 'get_keywords'
    }
}

export class KeywordsManagement__AddKeywordQuery extends KeywordsManagementQuery {
    constructor(params = new BaseParams()) {
        super()
        this._body.action = 'add'
    }
}

export class KeywordsManagement__AddKeywordListQuery extends KeywordsManagementQuery {
    constructor(params = new BaseParams()) {
        super()
        this._body.action = 'add-list'
    }
}

export class KeywordsManagement__DeleteKeywordQuery extends KeywordsManagementQuery {
    constructor(params = new BaseParams()) {
        super()
        this._body.action = 'delete'
    }
}

